import { isGeneratedCodingPracticeTest1Enabled } from 'bundles/assignment-submission/FeatureFlags';
import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';
import type { Item } from 'bundles/learner-progress/types/Item';

/**
 * Course Frame has been rolled out and isn't rolling back. However, the generated coding practice test still uses the old frame.
 * Clean this up old code paths after generated coding practice is done with them: https://coursera.atlassian.net/browse/CE-7113
 */
export const isCourseFrameEnabled = (computedItem?: Item): boolean => {
  if (computedItem) {
    const { courseId, id: itemId, contentSummary } = computedItem;

    const isUngradedAssignment = contentSummary.typeName === 'ungradedAssignment';

    const isCodingPracticeTest1Enabled = isGeneratedCodingPracticeTest1Enabled(courseId, itemId);

    const useNewCodingPracticeExperience = !(isCodingPracticeTest1Enabled && isUngradedAssignment);

    return useNewCodingPracticeExperience;
  } else {
    return true;
  }
};

/**
 * EPIC: https://tools.coursera.org/epic/experiment/DJASFX-NEfC-lAr_4rnFJw
 * @returns true if phase 3 should be shown in the UI.
 */
export const isCourseFramePhase3Enabled = (): boolean => {
  return LceCourseExperienceExperiments.get('isCourseFramePhase3Enabled') === true;
};
